import SenderService from '@/services/SenderService'

export default {
  actions: {
    async fetchSenderFields (ctx, remittanceOptionId) {
      const senderFields = await SenderService.methods.getSenderFields(remittanceOptionId)
      ctx.commit('updateSenderFields', senderFields.GetSenderFieldsResponse.FieldData.DetailedFieldData)
    }
  },
  mutations: {
    updateSenderFields (state, senderFields) {
      state.senderFields = senderFields.map((field) => {
        (Object.values(field).map((e, key) => {
          const objectKey = Object.keys(field)[key].charAt(0).toLowerCase() + Object.keys(field)[key].slice(1)
          if (e.hasOwnProperty('ValueDescription')) {
            Array.isArray(e.ValueDescription)
              ? e.ValueDescription.map(possibleValue => {
                Object.keys(possibleValue).forEach(posValKey => {
                  const possibleValuesKey = posValKey.charAt(0).toLowerCase() + posValKey.slice(1)
                  possibleValue[possibleValuesKey] = possibleValue[posValKey]._text
                  delete possibleValue[posValKey]
                })
              })
              : [e.ValueDescription].map(possibleValue => {
                const possibleValuesKey = Object.keys(possibleValue)[0].charAt(0).toLowerCase() + Object.keys(possibleValue)[0].slice(1)
                possibleValue[possibleValuesKey] = possibleValue.Value._text
              })
            const tmp = e.ValueDescription; e = []; e.push(...tmp)
            field[objectKey] = e
          } else {
            field[objectKey] = e._text
          }
        }))
        return field
      })
    }
  },
  getters: {
    getSenderFields (state) {
      return state.senderFields
    }
  },
  state: {
    senderFields: []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sender.js